/** @jsx jsx */
import { Box, Grid, Heading, jsx } from "theme-ui";
import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { PageFooterQuery } from "../../../graphql-types";
import FlexCol, { FlexRow } from "../flex/flex";
import RockitLink from "../link/rockit-link";
import RockitImage from "../image/image";
import Copyright from "../copyright/copyright.component";
import MailchimpForm from "../forms/mailchimp-form";
import Markdown from "../markdown/markdown";
import AuthButton from "../buttons/authButton";

export type PageFooterProps = {};
export const PageFooter: React.FC<PageFooterProps> = ({}) => {
  const footerData =
    useStaticQuery<PageFooterQuery>(query).contentfulSiteSettings;

  const locations = footerData.defaultFooter.locations.map((loc) => (
    <FlexCol key={loc.label} autoSave="li" sx={{ width: "fit-content" }}>
      <Box color="primary">{loc.label}</Box>
      <a
        sx={{ color: "white", textDecoration: "underline" }}
        href={`tel:${loc.phone}`}
      >
        {loc.phone}
      </a>
    </FlexCol>
  ));

  const menuItems = footerData.defaultFooter.navigation.navItems.map((item) => (
    <Box
      key={item.label}
      as="li"
      px={[2]}
      sx={{ fontWeight: "bold", fontSize: [1] }}
    >
      <RockitLink to={item.linksTo.slug}>{item.label}</RockitLink>
    </Box>
  ));

  return (
    <Box bg="gray">
      <Box py={[3]} variant="layout.box" sx={{ width: "100%" }}>
        <FlexCol alignItems={["center"]} sx={{ width: "100%" }}>
          <RockitImage
            alt={"Logo"}
            gatsbyImageData={footerData.companyLogo.gatsbyImageData}
          />
          <Grid
            py={[3, 0]}
            columns={["1fr", "1fr 60% 1fr"]}
            sx={{ width: "100%" }}
          >
            <FlexCol alignItems={["center", "flex-start"]}>
              <Heading as="h3" color="primary" sx={{ fontSize: [2] }}>
                Clinic Hours
              </Heading>
              <Box color="white" as="p">
                Monday - Friday, 9.00-5.00pm
              </Box>
            </FlexCol>
            <Grid
              my={[3]}
              as="ul"
              columns={[2, 3]}
              sx={{ width: "100%", justifyItems: ["center"] }}
            >
              {locations}
            </Grid>
            <FlexCol alignItems={["center", "flex-start"]}>
              <Heading as="h3" color="primary" sx={{ fontSize: [3] }}>
                {footerData.defaultFooter.newsletterHeading}
              </Heading>
              <Markdown
                sx={{ color: "white" }}
                data={
                  footerData.defaultFooter.newsletterMessage.childMarkdownRemark
                }
              />
              <MailchimpForm />
            </FlexCol>
          </Grid>
          <FlexRow color="white" as="ul">
            <Copyright />
            {menuItems}
          </FlexRow>
          <AuthButton />
        </FlexCol>
      </Box>
    </Box>
  );
};

export default PageFooter;

const query = graphql`
  query PageFooter {
    contentfulSiteSettings {
      defaultFooter {
        newsletterHeading
        newsletterMessage {
          childMarkdownRemark {
            ...Markdown
          }
        }
        locations {
          label
          addressName
          phone
        }
        navigation {
          ...Nav
        }
      }
      companyLogo {
        gatsbyImageData(height: 50, layout: FIXED)
      }
    }
  }
`;
